<template>
  <div>
    <ForeignOrganization :v="v" />

    <TrusteeView
      :v="v.trustee"
      label="Сведения о представителе иностранного юридического лица"
    />
  </div>
</template>

<script>
import deepmerge from 'deepmerge';
import { required } from 'vuelidate/lib/validators';

import TrusteeView, {
  trusteeModel,
  trusteeValidate,
} from '@/components/services/elements/TrusteeView';
import ForeignOrganization, {
  foreignOrganizationModel,
  foreignOrganizationValidation,
} from '../ForeignOrganization';

export const manualForeignOrganizationModel = deepmerge(
  foreignOrganizationModel,
  {
    trustee: trusteeModel,
  }
);

export const getManualForeignOrganizationValidation = (
  foreignOrganization
) => ({
  ...foreignOrganizationValidation,
  trustee: deepmerge(trusteeValidate(foreignOrganization.trustee), {
    email: {
      required,
    },
    phone: {
      required,
    },
  }),
});

export default {
  name: 'ManualForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: { ForeignOrganization, TrusteeView },
};
</script>
